<!-- acesso ao sistema quando o usuário não está pendente ou bloqueado -->
<mat-sidenav-container
  *ngIf="ehUsuarioValido()"
  [hasBackdrop]="true"
  class="sidenav-container h-100">

  <mat-sidenav
    [mode]="'side'"
    autoFocus="false"
    class="p-3"
    #sidenav
    [(opened)]="isMenuOpen"
    class="sidenav">

      <nav>

          <mat-nav-list>

            <div class="nav-item drop-down">

              <a mat-button class="nav-link dropdown-toggle" data-toggle="collapse"
                href="#lancamentos" role="button" aria-expanded="false" aria-controls="lancamentos">
                <fa-icon [icon]="faReleases" class="pr-1"></fa-icon>
                Lançamentos
              </a>

              <div class="collapse" id="lancamentos">

                <a class="nav-link" mat-button routerLink="/inicio/agenda">
                  <div class="pl-4">
                    <fa-icon [icon]="faSchedule" class="pr-1"></fa-icon>
                    Agenda
                  </div>
                </a>

                <mat-divider></mat-divider>

                <div class="nav-item drop-down">

                  <a mat-button class="nav-link dropdown-toggle ml-4" data-toggle="collapse" href="#matrix"
                    role="button" aria-expanded="false" aria-controls="matrix">
                      <img alt="matriz" src="./assets/images/matriz.svg" height="20" width="20"/>
                     Matrizes
                  </a>

                  <div class="collapse ml-4" id="matrix">

                    <span>
                      <a mat-button class="dropdown-item ml-4" routerLink="/inicio/matriz/historico">
                        <fa-icon [icon]="faMatrixHistory" class="pr-1"></fa-icon>
                        Histórico Matriz
                      </a>
                    </span>

                    <span>
                      <a mat-button class="dropdown-item ml-4" routerLink="/inicio/matriz/cadastro">
                        <fa-icon [icon]="faMatrixRegister" class="pr-1"></fa-icon>
                        Cadastro
                      </a>
                    </span>

                  </div>

                </div>

                <mat-divider></mat-divider>

                <div class="nav-item drop-down">

                  <a mat-button class="nav-link dropdown-toggle ml-4" data-toggle="collapse" href="#reproduction" role="button"
                    aria-expanded="false" aria-controls="reproduction">
                      <fa-icon [icon]="faReproduction" class="pr-1"></fa-icon>
                      Reprodução
                  </a>

                  <div class="collapse ml-4" id="reproduction">

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/reproducao/iatf">
                      <fa-icon [icon]="faIATF" class="pr-1"></fa-icon>
                      IATF
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/reproducao/ocorrencias">
                      <fa-icon [icon]="faReproductionOcurrence" class="pr-1"></fa-icon>
                      Ocorrências Reprodução
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/reproducao/ia-cob-te">
                      <img alt="ia-cob-te" src="./assets/images/ia-cob-te.svg" height="20" width="20"/>
                      IA/Cob/TE Toques
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/reproducao/partos">
                      <img alt="matriz-parto" src="./assets/images/matriz-parto.svg" height="20" width="20"/>
                      Partos
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/reproducao/consulta">
                      <fa-icon [icon]="faQuery" class="pr-1"></fa-icon>
                      Consulta
                    </a>

                  </div>

                </div>

                <mat-divider></mat-divider>

                <div class="nav-item drop-down">

                  <a mat-button class="nav-link dropdown-toggle ml-4" data-toggle="collapse" href="#production" role="button"
                    aria-expanded="false" aria-controls="production">
                      <fa-icon [icon]="faProduction" class="pr-1"></fa-icon>
                      Produção
                  </a>

                  <div class="collapse ml-4" id="production">
                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/producao/controle-leiteiro">
                      <fa-icon [icon]="faDairyControl" class="pr-1"></fa-icon>
                      Controles Leiteiros
                    </a>
                  </div>

                  <div class="collapse ml-4" id="production">
                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/producao/secagem">
                      <fa-icon [icon]="faDryings" class="pr-1"></fa-icon>
                      Secagens
                    </a>
                  </div>

                  <div class="collapse ml-4" id="production">
                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/producao/exportar-controles-leiteiros">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Exportar Controles Leiteiros
                    </a>
                  </div>

                </div>

                <mat-divider></mat-divider>

                <div class="nav-item drop-down">

                  <a mat-button class="nav-link dropdown-toggle ml-4" data-toggle="collapse" href="#configurations"
                    role="button" aria-expanded="false" aria-controls="configurations">
                      <fa-icon [icon]="faConfigurations" class="pr-1"></fa-icon>
                      Configurações
                  </a>

                  <div class="collapse ml-4" id="configurations">

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/configuracao/reprodutor">
                      <fa-icon [icon]="faBreeders" class="pr-1"></fa-icon>
                      Semen Touros
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/configuracao/composicao-racial">
                      <fa-icon [icon]="faRacialComposition" class="pr-1"></fa-icon>
                      Composições Raciais
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/configuracao/lote">
                      <fa-icon [icon]="faLots" class="pr-1"></fa-icon>
                      Lotes
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/configuracao/inseminador">
                      <fa-icon [icon]="faInseminators" class="pr-1"></fa-icon>
                      Inseminadores
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/configuracao/protocolo">
                      <fa-icon [icon]="faProtocols" class="pr-1"></fa-icon>
                      Protocolos
                    </a>

                  </div>

                </div>

                <mat-divider></mat-divider>

                <div class="nav-item drop-down">

                  <a mat-button class="nav-link dropdown-toggle ml-4" data-toggle="collapse" href="#imports" role="button"
                    aria-expanded="false" aria-controls="imports">
                      <fa-icon [icon]="faImports" class="pr-1"></fa-icon>
                      Importações
                  </a>

                  <div class="collapse ml-4" id="imports">

                    <div class="collapse" id="imports">
                      <a mat-button class="dropdown-item ml-4" routerLink="/inicio/importacao/matrizes">
                        <fa-icon [icon]="faImportMatrix" class="pr-1"></fa-icon>
                          Matrizes
                      </a>
                    </div>

                  </div>

                  <div class="collapse ml-4" id="imports">

                    <div class="collapse" id="imports">
                      <a mat-button class="dropdown-item ml-4" routerLink="/inicio/importacao/reproducao">
                        <fa-icon [icon]="faImportMatrix" class="pr-1"></fa-icon>
                          Reprodução
                      </a>
                    </div>

                  </div>

                  <div class="collapse ml-4" id="imports">

                    <div class="collapse" id="imports">
                      <a mat-button class="dropdown-item ml-4" routerLink="/inicio/importacao/controle-leiteiro">
                        <fa-icon [icon]="faImportMatrix" class="pr-1"></fa-icon>
                          Produção
                      </a>
                    </div>

                  </div>

                  <div class="collapse ml-4" id="imports">

                    <div class="collapse" id="imports">
                      <a mat-button class="dropdown-item ml-4" routerLink="/inicio/importacao/reprodutor">
                        <fa-icon [icon]="faImportMatrix" class="pr-1"></fa-icon>
                        Reprodutor
                      </a>
                    </div>

                  </div>

                  <div *ngIf="ehUsuarioAdministrador()" class="collapse ml-4" id="imports">

                    <div class="collapse" id="imports">
                      <a mat-button class="dropdown-item ml-4" routerLink="/inicio/importacao/base-touros">
                        <fa-icon [icon]="faImportMatrix" class="pr-1"></fa-icon>
                        Base Touros
                      </a>
                    </div>

                  </div>

                </div>

                <mat-divider></mat-divider>

                <a mat-button class="dropdown-item ml-4" routerLink="/inicio/cadastro/parametro">
                  <fa-icon [icon]="faParameterCrud" class="pr-1"></fa-icon>
                  Parâmetros
                </a>

              </div>

            </div>

            <!-- <mat-divider></mat-divider> -->

            <!-- <a class="nav-link" mat-button routerLink="/condicoes-uso">
              <div>
                Condições de uso
              </div>
            </a> -->

            <mat-divider></mat-divider>

            <div class="nav-item drop-down">

              <a mat-button class="nav-link dropdown-toggle" data-toggle="collapse"
                href="#consultas" role="button" aria-expanded="false" aria-controls="consultas">
                <fa-icon [icon]="faRelatorios" class="pr-1"></fa-icon>
                Relatórios
              </a>

              <div class="collapse ml-4" id="consultas">

                <a class="nav-link" mat-button routerLink="/inicio/dashboard">

                  <div>
                    <fa-icon [icon]="faDashboard" class="pr-1"></fa-icon>
                    Dashboard
                  </div>

                </a>

                <mat-divider></mat-divider>

                <div class="nav-item drop-down">

                  <a mat-button class="nav-link dropdown-toggle" data-toggle="collapse" href="#analises" role="button"
                    aria-expanded="false" aria-controls="analises">
                      <fa-icon [icon]="faAnalysis" class="pr-1"></fa-icon>
                      Análises
                  </a>

                  <div class="collapse ml-2" id="analises">

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/analises/distribuicao-prenhezes-del">
                      <fa-icon [icon]="faPregnacyDelDistribution" class="pr-1"></fa-icon>
                      Dist. Prenhezes por Del
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/analises/distribuicao-del-servicos">
                      <fa-icon [icon]="faServicesDelDitribution" class="pr-1"></fa-icon>
                      Dist. por Del nos serviços
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/analises/intervalo-entre-servicos">
                      <fa-icon [icon]="faServicesInterval" class="pr-1"></fa-icon>
                      Intervalo entre serviços
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/analises/perda-prenhez">
                      <fa-icon [icon]="faPregnancyLost" class="pr-1"></fa-icon>
                      Perda de prenhez
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/analises/projecao-vacas-lactacao">
                      <fa-icon [icon]="faLactationCowsExpected" class="pr-1"></fa-icon>
                      Proj. vacas em lactação
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/analises/taxa-servico-prenhez">
                      <fa-icon [icon]="faPregnancyServiceRate" class="pr-1"></fa-icon>
                      Taxa serviço/prenhez
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/analises/idade-primeira-ia">
                      <fa-icon [icon]="faServicesDelDitribution" class="pr-1"></fa-icon>
                      Idade no serviço
                    </a>

                  </div>

                </div>

                <mat-divider></mat-divider>

                <div class="nav-item drop-down">

                  <a mat-button class="nav-link dropdown-toggle" data-toggle="collapse" href="#taxaconcepcao" role="button"
                    aria-expanded="false" aria-controls="taxaconcepcao">
                      <fa-icon [icon]="faConceptionRate" class="pr-1"></fa-icon>
                      Taxa Concepção
                  </a>

                  <div class="collapse ml-2" id="taxaconcepcao">

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/taxa-concepcao/del">
                      <fa-icon [icon]="faConceptionRateByDEl" class="pr-1"></fa-icon>
                      Por del
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/taxa-concepcao/grau-sangue">
                      <fa-icon [icon]="faConceptionRateByBloodGrade" class="pr-1"></fa-icon>
                      Por grau de sangue
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/taxa-concepcao/inseminador">
                      <fa-icon [icon]="faConceptionRateByInseminator" class="pr-1"></fa-icon>
                      Por inseminador
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/taxa-concepcao/intervalo-entre-servico">
                      <fa-icon [icon]="faConceptionRateByServiceInteraval" class="pr-1"></fa-icon>
                      Por intervalo entre serviço
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/taxa-concepcao/mes">
                      <fa-icon [icon]="faConceptionRateByMonth" class="pr-1"></fa-icon>
                      Por mês
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/taxa-concepcao/numero-servico">
                      <fa-icon [icon]="faConceptionRateByServiceNumber" class="pr-1"></fa-icon>
                      Por número de serviços
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/taxa-concepcao/tipo-servico">
                      <fa-icon [icon]="faConceptionRateByServiceType" class="pr-1"></fa-icon>
                      Por tipo de serviço
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/taxa-concepcao/touro">
                      <fa-icon [icon]="faConceptionRateByBreeder" class="pr-1"></fa-icon>
                      Por touro
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/taxa-concepcao/protocolo">
                      <fa-icon [icon]="faConceptionRateByProtocol" class="pr-1"></fa-icon>
                      Por protocolo
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/taxa-concepcao/ordem-parto">
                      <fa-icon [icon]="faConceptionRateByParturitionOrder" class="pr-1"></fa-icon>
                      Por ordem de parto
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/taxa-concepcao/concatenada">
                      <fa-icon [icon]="faConceptionRateConcatenated" class="pr-1"></fa-icon>
                      Concatenada
                    </a>

                  </div>

                </div>

                <mat-divider></mat-divider>

                <div class="nav-item drop-down">

                  <a mat-button class="nav-link dropdown-toggle" data-toggle="collapse" href="#listing" role="button"
                    aria-expanded="false" aria-controls="listing">
                      <fa-icon [icon]="faList" class="pr-1"></fa-icon>
                      Listagem
                  </a>

                  <div class="collapse ml-2" id="listing">

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/avaliacao-grau-de-sangue">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Avaliação por grau de sangue
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/acompanhamento-geral-rebanho">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Acompanhamento geral do rebanho
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/matrizes-doadora">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Doadoras
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/matrizes-no-pev">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Matrizes no PEV
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/matrizes-problema">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Matrizes problema
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/matrizes-a-servir">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Matrizes a servir
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/matrizes-gestantes">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Matrizes gestantes
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/matrizes-servidas">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Matrizes servidas
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/previsao-partos">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Previsão de Partos
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/producao-leite">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Produção de leite
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/secagem">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Secagens
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/servicos">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Serviços
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/toque-confirmacao">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Toque e confirmação
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/alta-cria">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Alta Cria
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/listagem/concept-plus-leite">
                      <fa-icon [icon]="faCircle" class="pr-1"></fa-icon>
                      Concept Plus Leite
                    </a>

                  </div>

                </div>

                <mat-divider></mat-divider>

                <div class="nav-item drop-down">

                  <a mat-button class="nav-link dropdown-toggle" data-toggle="collapse" href="#altacria" role="button"
                    aria-expanded="false" aria-controls="altacria">
                      <fa-icon [icon]="faAltaCria" class="pr-1"></fa-icon>
                      Alta Cria
                  </a>

                  <div class="collapse ml-2" id="altacria">

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/alta-cria/colostragem-mortalidade">
                      <fa-icon [icon]="faColostragemMortalidade" class="pr-1"></fa-icon>
                        Colostragem X Mortalidade
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/alta-cria/ganho-peso-meta">
                      <fa-icon [icon]="faGanhoPesoMeta" class="pr-1"></fa-icon>
                        Ganho Peso X Meta
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/alta-cria/gpd-quantidade-doencas">
                      <fa-icon [icon]="faGpdQtdDoencas" class="pr-1"></fa-icon>
                        GPD X Qtd. Doenças
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/alta-cria/idade-doencas">
                      <fa-icon [icon]="faAgeDeseases" class="pr-1"></fa-icon>
                        Idade X Doenças
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/alta-cria/numero-doencas-meses">
                      <fa-icon [icon]="faDeseasesNumberMonths" class="pr-1"></fa-icon>
                        Nº Doenças X Meses
                    </a>

                  </div>

                </div>

                <mat-divider></mat-divider>

                <a class="nav-link" mat-button routerLink="/inicio/simulador-reproducao">
                  <div>
                    <fa-icon [icon]="faReproductionSimulator" class="pr-1"></fa-icon>
                    Simulador Reprodução
                  </div>
                </a>

                <mat-divider></mat-divider>

                <a class="nav-link" mat-button routerLink="/inicio/ficha-individual">
                  <div>
                    <fa-icon [icon]="faSearchPlus" class="pr-1"></fa-icon>
                    Ficha Individual
                  </div>
                </a>

                <mat-divider></mat-divider>

                <div class="nav-item drop-down">

                  <a mat-button class="nav-link dropdown-toggle" data-toggle="collapse" href="#benchmarking" role="button" aria-expanded="false" aria-controls="benchmarking">
                    <fa-icon [icon]="faBenchmarking" class="pr-1"></fa-icon>
                    Benchmarking
                  </a>

                  <div class="collapse ml-2" id="benchmarking">

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/benchmarking/global">
                      <fa-icon [icon]="faBenchmarkingGlobal" class="pr-1"></fa-icon>
                        Global
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/benchmarking/estado">
                      <fa-icon [icon]="faBenchmarkingEstado" class="pr-1"></fa-icon>
                        Por estado
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/benchmarking/mesorregiao">
                      <fa-icon [icon]="faBenchmarkingMesorregiao" class="pr-1"></fa-icon>
                        Por mesorregião
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/benchmarking/perfil-rebanho">
                      <fa-icon [icon]="faBenchmarkingPerfilRebanho" class="pr-1"></fa-icon>
                        Por perfil de rebanho
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/benchmarking/sistema-producao">
                      <fa-icon [icon]="faBenchmarkingSistemaProducao" class="pr-1"></fa-icon>
                        Por sistema de produção
                    </a>

                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/benchmarking/grupo-fazenda">
                      <fa-icon [icon]="faBenchmarkingSistemaProducao" class="pr-1"></fa-icon>
                        Por grupo de fazendas
                    </a>

                  </div>

                </div>

                <mat-divider></mat-divider>

                <div *ngIf="ehUsuarioAdministrador()" class="nav-item drop-down">

                  <a mat-button class="nav-link dropdown-toggle" data-toggle="collapse" href="#relatorios" role="button"
                    aria-expanded="false" aria-controls="relatorios">
                      <fa-icon [icon]="faRelatorios" class="pr-1"></fa-icon>
                      Relatórios
                  </a>

                  <div class="collapse ml-2" id="relatorios">
                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/relatorio/envio">
                      <fa-icon [icon]="faRelatorioDown" class="pr-1"></fa-icon>
                        Acessos / Envios
                    </a>
                  </div>

                  <div class="collapse ml-2" id="relatorios">
                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/relatorio/envio-mes">
                      <fa-icon [icon]="faRelatorioDown" class="pr-1"></fa-icon>
                        Acessos / Envios Por Mês
                    </a>
                  </div>

                  <div class="collapse ml-2" id="relatorios">
                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/relatorio/envio-usuario">
                      <fa-icon [icon]="faRelatorioDown" class="pr-1"></fa-icon>
                        Acessos / Envios Por Usuários
                    </a>
                  </div>

                  <div class="collapse ml-2" id="relatorios">
                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/relatorio/envio-fazenda">
                      <fa-icon [icon]="faRelatorioDown" class="pr-1"></fa-icon>
                        Acessos / Envios Por Fazendas
                    </a>
                  </div>

                  <div class="collapse ml-2" id="relatorios">
                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/relatorio/usuarios-inativos">
                      <fa-icon [icon]="faRelatorioDown" class="pr-1"></fa-icon>
                        Usuários Inativos
                    </a>
                  </div>

                  <div class="collapse ml-2" id="relatorios">
                    <a mat-button class="dropdown-item ml-4" routerLink="/inicio/relatorio/analise-alta-gestao">
                      <fa-icon [icon]="faRelatorioDown" class="pr-1"></fa-icon>
                        Análise Alta Gestão
                    </a>
                  </div>

                </div>

                <mat-divider></mat-divider>

                <div class="nav-item drop-down">

                  <a mat-button class="nav-link dropdown-toggle" data-toggle="collapse" href="#registers" role="button"
                    aria-expanded="false" aria-controls="registers">
                      <fa-icon [icon]="faRegister" class="pr-1"></fa-icon>
                      Cadastros
                  </a>

                  <div class="collapse ml-2" id="registers">

                    <div class="collapse" id="registers">
                      <a mat-button class="dropdown-item ml-4" routerLink="/inicio/cadastro/fazenda">
                        <fa-icon [icon]="faFarmCrud" class="pr-1"></fa-icon>
                          Fazenda
                      </a>
                    </div>

                    <div class="collapse" id="registers">
                      <a mat-button class="dropdown-item ml-4" routerLink="/inicio/cadastro/usuario">
                        <fa-icon [icon]="faUserCrud" class="pr-1"></fa-icon>
                          Usuário
                      </a>
                    </div>

                    <div class="collapse" id="registers">
                      <a *ngIf="ehUsuarioAdministrador()" mat-button class="dropdown-item ml-4" routerLink="/inicio/cadastro/grupo">
                        <fa-icon [icon]="faGroupCrud" class="pr-1"></fa-icon>
                          Grupo
                      </a>
                    </div>

                  </div>

                </div>

              </div>

            </div>

            <mat-divider></mat-divider>

            <div class="nav-item">
              <a mat-button class="nav-link" routerLink="/inicio/politica-privacidade">
                <fa-icon [icon]="faPrivacyPolicy" class="pr-1"></fa-icon>
                Política de Privacidade
              </a>
            </div>

          </mat-nav-list>

          <mat-nav-list>
              <a mat-list-item matTooltip="Sair" routerLink="" (click)="openLogoutDialog()">
                <div class="d-flex align-items-center justify-content-start">
                  <mat-icon>logout</mat-icon>
                  <span class="ml-2">Sair</span>
                </div>
              </a>
          </mat-nav-list>

      </nav>

  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content h-100"> 

      <mat-toolbar class="mat-elevation-z4 mat-toolbar p-1 custom-toolbar-shadow">

          <mat-toolbar-row>

              <button mat-icon-button class="menu-button text-white" (click)="sidenav.toggle();">
                <mat-icon>{{ isMenuOpen ? 'menu_open' : 'menu' }}</mat-icon>
              </button>

              <a href="/">
                <img class="img-fluid" src="../assets/images/alta-gestao-topo-branca.png" alt="Alta Gestão">
              </a>

              <span class="spacer"></span>

              <div class="pr-2">

                  <button mat-button *ngIf="ehUsuarioVeterinario()" matTooltip="Alterar fazenda"
                    class="clickable text-white pt-1 pr-0" (click)="abrePopupAlteracaoFazenda()">
                    <mat-icon>cached</mat-icon>
                    {{ nomeFazenda }}

                    <span *ngIf="!nomeFazenda" class="user-farm text-white">
                      Nenhuma fazenda selecionada
                    </span>

                  </button>

                  <span *ngIf="!ehUsuarioVeterinario()" class="user-farm text-white pt-1 pr-0">
                    {{ nomeFazenda }}
                  </span>

              </div>

              <div class="border-left p-1 pl-2 pr-2">

                <span class="user-name text-white" matTooltip="{{ emailUsuario }}">
                  {{ nomeUsuario }}
                </span>

              </div>

              <div class="border-left justify-content-center align-items-center">

                <button mat-icon-button matTooltip="Sair" class="clickable text-white" (click)="openLogoutDialog()">
                  <mat-icon>exit_to_app</mat-icon>
                </button>

              </div>

          </mat-toolbar-row>

      </mat-toolbar>

      <div class="mt-4 justify-content-center align-items-center">
        <router-outlet></router-outlet>
      </div>

  </mat-sidenav-content>

</mat-sidenav-container>

<div *ngIf="ehUsuarioValido()" class="footer d-flex align-items-center">
  <span class="pl-6">© {{ anoAtual }} Alta Genetics do Brasil</span>
  <span class="ml-2 mr-2">|</span>
  <span class="version-link" (click)="abrirReleaseNotesManualmente()" title="Ver novidades da versão">
    Versão
  </span>
</div>

<!-- acesso negado ao sistema quando o usuário está pendente ou bloqueado -->
<div *ngIf="ehUsuarioBloqueadoOuPendente()" class="h-100 row justify-content-center align-items-center">

  <mat-card>

    <mat-card-header class="p-4 text-center">
      <span>
        O usuário <strong>{{ emailUsuario }}</strong> está bloqueado ou pendente de liberação.
        <br>Por favor entre em contato com o administrador do sistema no email
        <strong>altagestao@altagenetics.com.br</strong> ou no telefone <strong>(34) 3318-3327</strong>.
      </span>
    </mat-card-header>

    <mat-card-actions class="text-center p-4">
      <button
        mat-mdc-raised-button
        class="btn btn-submit"
        matTooltip="Clique para retornar a tela inicial"
        style="width: 120px;"
        (click)="logout()">
        Voltar
      </button>
    </mat-card-actions>

  </mat-card>

</div>

<div *ngIf="erroCadastroAzure" class="h-100 row justify-content-center align-items-center">

  <mat-card>

    <mat-card-header class="p-4 text-center">
      <span>
        Ocorreu um erro no seu cadastro.
        <br>Por favor entre em contato com o administrador do sistema no email
        <strong>altagestao@altagenetics.com.br</strong> ou no telefone <strong>(34) 3318-3327</strong>.
      </span>
    </mat-card-header>

    <mat-card-actions class="text-center p-4 justify-content-center">
      <button
        mat-mdc-raised-button
        class="btn btn-submit"
        matTooltip="Clique para retornar a tela inicial"
        style="width: 120px;"
        (click)="logout()">
        Voltar
      </button>
    </mat-card-actions>

  </mat-card>

</div>

<!-- erro interno no sistema -->
<div *ngIf="erro !== undefined && erro.length > 0" class="h-100 row justify-content-center align-items-center">

  <mat-card>

    <mat-card-header class="p-4 text-center">
      <span>
        <strong>{{ erro }}</strong>
      </span>
    </mat-card-header>

    <mat-card-actions class="text-center p-2">
      <button
        mat-mdc-raised-button
        class="btn btn-submit"
        matTooltip="Clique para retornar a tela inicial"
        style="width: 120px;"
        (click)="logout()">
        Voltar
      </button>
    </mat-card-actions>

  </mat-card>

</div>

<div *ngIf="fazendaProprietarioExiste" class="h-100 row justify-content-center align-items-center">

  <mat-card>

    <mat-card-header class="p-4 text-center">
      <span>
        <strong>A fazenda <span class="text-danger">{{this.claims.extension_Farm}}</span> e proprietário <span class="text-danger">{{this.claims.extension_FarmOwner}}</span> já estão cadastrados no sistema. 
          <br> Por favor atualize os dados abaixo.</strong>
      </span>
    </mat-card-header>

    <mat-form-field class="col-12 col-sm-12" appearance="outline">
        <mat-label>
                Nome da Fazenda
                <span class="required">*</span>
        </mat-label>
        <input aria-label="fazenda" matInput [(ngModel)]="nomeFazendaEscolhida" >
    </mat-form-field> 

    <mat-form-field class="col-12 col-sm-12" appearance="outline">
        <mat-label>
                Proprietário
                <span class="required">*</span>
        </mat-label>
        <input aria-label="fazenda" matInput [(ngModel)]="nomeProprietarioEscolhido" >
    </mat-form-field> 

    <mat-card-actions class="text-center p-2">
      <button
        mat-mdc-raised-button
        class="btn btn-submit"
        matTooltip="Clique para retornar a tela inicial"
        style="width: 120px;"
        (click)="insereUsuarioCadastradoNaAzure()">
        Atualizar
      </button>
    </mat-card-actions>

  </mat-card>

</div>
